var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backtest-macd-optimize-view"},[_c('BacktestMACDOptimize')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }